import { pathToComponentName } from "common/componentHelpers";
import type { App, Component } from "vue";

export default {
  install: (app: App) => {
    Object.entries(
      import.meta.glob<Array<Component>>("./*.vue", {
        eager: true,
        import: "default",
      }),
    ).forEach(([filePath, definition]) => {
      const componentName = pathToComponentName(filePath);

      app.component(componentName, definition);
    });
  },
};
